export enum SideBarKeys {
  COMPONENTS = "components",
  NAVIGATION = "navigation",
  STATE_VARS = "state-vars",
  TIMERS = "timers",
  SETTINGS_PROFILES = "settings_profiles",
  DEVELOPER_PREFERENCES = "developer_preferences",
  EMBEDDING = "embedding",
  DEBUGGER = "debugger",
  CUSTOM_COMPONENTS = "custom-components",
  VERSIONS = "versions",
  COMMAND_BAR = "command-bar",
  THEME = "theme",
  CUSTOM_EVENTS = "custom-events",
  AI_CHAT = "ai-chat",
}
